// @flow
import { useCallback, useState } from 'react';


export default function useIsExpandable(empty: boolean): [(node: ?HTMLElement) => void, boolean] {
  const [expandable, setExpandable] = useState(false);

  const refFunc = useCallback((node: ?HTMLElement) => {
    if (node && !empty) {
      const { width } = node.getBoundingClientRect();
      const { width: parentWidth } = node.parentElement ? node.parentElement.getBoundingClientRect() : {};
      setExpandable(parentWidth < width);
      return;
    }
    setExpandable(false);
  }, [empty]);

  return [refFunc, expandable];
}
